import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SelectIcon(props) {
    return (React.createElement(Svg, { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Rect, { width: 40, height: 40, rx: 20, fill: "#F3F5FC" }),
        React.createElement(Path, { d: "M23.533 18.484a1.5 1.5 0 100-3 1.5 1.5 0 000 3z", fill: "#1434CB" }),
        React.createElement(Path, { d: "M11.033 13.484a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2h-14a2 2 0 01-2-2v-14zm16 0h-14v7.92l3.375-2.7a1 1 0 011.25 0l4.3 3.44 1.368-1.367a1 1 0 011.414 0l2.293 2.293v-9.586zm-14 14h14v-1.586l-3-3-1.293 1.293a1 1 0 01-1.332.074l-4.375-3.5-4 3.2v3.52z", fill: "#1434CB" })));
}
export default SelectIcon;
